import { useState } from "react";
import { useMount } from "react-use";

/**
 * Hook that returns `false` during SSR and initial hydration, then `true` after mount.
 *
 * Use this to safely defer rendering of client-only content that would cause
 * hydration mismatches (e.g., content that depends on `window`, `localStorage`,
 * iframe detection, or other browser-only APIs).
 *
 * @example
 * ```tsx
 * const isMounted = useIsMounted();
 * const isInIframe = isMounted && checkIsInIframe();
 * ```
 */
export function useIsMounted(): boolean {
	const [isMounted, setIsMounted] = useState(false);

	useMount(() => {
		setIsMounted(true);
	});

	return isMounted;
}
